<template>
  <div class="dashboard__head">
    <div class="dashboard__head-main">
      <button class="js-toggle-dashboard-sidebar dashboard__button-menu">
        <div class="dashboard__button-menu-icon">
          <img src="/static/img/admin/menu.svg" alt="" class="dashboard__button-menu-icon-img">
        </div>
        <div class="dashboard__button-menu-text">Expand Menu</div>
      </button>
      <nav class="dashboard__head-nav">
        <a href="#" class="dashboard__head-nav-item">Promotions</a>
        <a href="#" class="dashboard__head-nav-item">Manual</a>
      </nav>
    </div>
    <div class="dashboard__head-helpers">
      <div class="dashboard__head-balance">
        <div class="dashboard__head-balance-label">ACCOUNT BALANCE</div>
        <div class="dashboard__head-balance-sum">$ {{ balance }}</div>
      </div>
      <div class="dashboard__head-controls">
        <b-btn href="#" class="button button--big button--success dashboard__head-button">ADD FUNDS</b-btn>
        <b-btn class="button button--big button--danger dashboard__head-button" @click="logout">LOGOUT</b-btn>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import {AUTH_LOGOUT} from '@/store/actions/auth'

export default {
  name: 'Header',
  methods: {
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push('/')
      })
    }
  },
  computed: {
    balance: function () {
      return this.$store.getters.getBalance
    }
  },
  mounted: function () {
    // Expand menu
    $('.js-toggle-dashboard-sidebar').on('click', function () {
      $('.dashboard').toggleClass('dashboard--active')
    })
  }
}
</script>

<style>
.dashboard__head-button{
  border: none;
}
.button--big {
    padding: 1.2rem 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/advertiser/header.vue